import { render, staticRenderFns } from "./bannerDesc.vue?vue&type=template&id=677c1993&scoped=true"
import script from "./bannerDesc.vue?vue&type=script&lang=js"
export * from "./bannerDesc.vue?vue&type=script&lang=js"
import style0 from "./bannerDesc.vue?vue&type=style&index=0&id=677c1993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677c1993",
  null
  
)

export default component.exports